module.exports = __webpack_public_path__ + "img/activity-cover.8e8be616.png";